import { useSyncExternalStore } from 'react';

/** Modo presentación (oculta sidebar/topbar y paneles secundarios). Estado de UI global, no persistido. */
let on = false;
const listeners = new Set<() => void>();

export const setPresentation = (v: boolean): void => {
  if (on === v) return;
  on = v;
  for (const l of listeners) l();
};

export function usePresentation(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => on,
    () => false,
  );
}

export const getPresentation = (): boolean => on;
